import createLeadFieldSelect from "./createLeadFieldSelect";

export default createLeadFieldSelect("/leads/all_closest_office_addresses", {
  displayName: "ClosestOfficeAddressSelect",
  defaultPlaceholder: "Select Closest Office Address",
});
